import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { linksEvent, LinksEventType } from '/@/libs/eventBus';

export function useRefreshPage() {
  const showPage = ref(true);
  function refreshPage() {
    showPage.value = false;
    nextTick(() => {
      showPage.value = true;
    });
  }

  onMounted(() => {
    linksEvent.on(LinksEventType.reloadPage, refreshPage);
  });

  onBeforeUnmount(() => {
    linksEvent.off(LinksEventType.reloadPage, refreshPage);
  });

  return {
    showPage,
  };
}
